import { render, staticRenderFns } from "./FooterBlock.vue?vue&type=template&id=0859cd30&scoped=true"
import script from "./FooterBlock.vue?vue&type=script&lang=js"
export * from "./FooterBlock.vue?vue&type=script&lang=js"
import style0 from "./FooterBlock.vue?vue&type=style&index=0&id=0859cd30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0859cd30",
  null
  
)

export default component.exports